export default "__VITE_ASSET__Qp7FBQ0B__";